import { applyAction } from "./appliers";
import type { IndianPokerAction, IndianPokerState } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: IndianPokerState,
  action: IndianPokerAction,
): IndianPokerState {
  if (!validateAction(state, action).valid) {
    return state;
  }

  return applyAction(state, action);
}
